export default "__VITE_ASSET__4e4fb6d9__"